<template>
	<div class="homeview">
		<el-container>
			<el-header>
				<!-- 模糊搜索 -->
				<el-select v-model="searchQuery" filterable clearable placeholder="请选择门店名称">
					<el-option v-for="item in jsonStore.storelist" :key="item.id" :label="item.label" :value="item.hotel_name">
					</el-option>
				</el-select>

				<!-- 日期范围 -->
				<el-date-picker v-model="Staydate" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" @change="updateIframeUrls" value-format="yyyy-MM-dd">
				</el-date-picker>
			</el-header>

			<el-container>
				<el-aside width="400px" ref="sideBar">
					<!-- 过滤后的门店列表显示 -->
					<div class="storename-max" v-for="(item, index) in filteredStoreList" :key="index">
						<iframe :src="getIframeSrc(item.url)" class="iframe-content" width="100%" height="200" frameborder="0"
							title="External Site" loading="lazy">
						</iframe>
					</div>
				</el-aside>

				<el-main>
					<!-- 过滤后的门店对应的内容显示 -->
					<div class="flex-max" v-for="(item, index) in filteredStoreList" :key="index">
						<div class="flxt" v-for="(iet, ind) in item.counterparts" :key="ind">
							<iframe :src="getIframeSrc(iet.url)" class="iframe-content" width="100%" height="200" frameborder="0"
								title="External Site" loading="lazy">
							</iframe>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import jsonStore from '../api/homename.json'

	export default {
		data() {
			return {
				jsonStore,
				searchQuery: '', // 搜索条件
				Staydate: '', // 住店日期范围
			};
		},
		created() {
			// 在组件初始化时，如果没有选择日期，默认选择第一个门店
			if (!this.searchQuery) {
				this.searchQuery = this.jsonStore.storelist[0].hotel_name;
			}
		},
		methods: {
			// 根据日期更新iframe的src链接，修改为带日期参数的URL
			updateIframeUrls() {
				if (this.Staydate && this.Staydate.length === 2) {
					this.checkIn = this.Staydate[0]; // 起始日期
					this.checkOut = this.Staydate[1]; // 截至日期

					// 确保根据新的日期更新iframe链接
					this.$nextTick(() => {
						// 更新每个iframe的src地址
						this.filteredStoreList.forEach(item => {
							item.url = this.getIframeSrc(item.url); // 更新主门店的iframe URL
							item.counterparts.forEach(counterpart => {
								counterpart.url = this.getIframeSrc(counterpart.url); // 更新对应门店的iframe URL
							});
						});
					});
				} else {
					this.checkIn = '';
					this.checkOut = '';
				}
			},

			// 根据日期更新URL并生成 iframe 的 src
			getIframeSrc(url) {
			    if (this.checkIn && this.checkOut) {
			        // 创建一个新的 URL 对象
			        const urlObj = new URL(url);
			
			        // 使用 URLSearchParams 来修改查询参数
			        const searchParams = new URLSearchParams(urlObj.search);
			
			        // 设置 checkIn 和 checkOut 参数
			        searchParams.set('checkIn', this.checkIn);
			        searchParams.set('checkOut', this.checkOut);
			
			        // 将更新后的查询参数赋回到 URL 对象
			        urlObj.search = searchParams.toString();
			
			        // 返回更新后的 URL
			        return urlObj.toString();
			    }
			    return url; // 如果没有日期信息，返回原始 URL
			}

		},

		computed: {
			  // 过滤后的门店列表
			  filteredStoreList() {
			    if (!this.searchQuery) {
			      return [this.jsonStore.storelist[0]]; // 如果没有选择门店名称，默认返回第一个门店
			    }
			
			    // 根据搜索条件过滤门店
			    return this.jsonStore.storelist.filter(store => store.hotel_name === this.searchQuery).map(store => {
			      // 更新门店主链接
			      store.url = this.getIframeSrc(store.url);
			
			      // 更新门店对应链接
			      store.counterparts.forEach(counterpart => {
			        counterpart.url = this.getIframeSrc(counterpart.url);
			      });
			
			      return store;
			    });
			  }
		}
	};
</script>

<style lang="scss" scoped>
	.homeview {
		margin: 0;
		padding: 0;
	}

	.el-header,
	.el-footer {
		background-color: #b3c0d1;
		color: #333;
		text-align: center;
		line-height: 60px;
	}

	.el-aside {
		overflow-y: auto;
		background-color: #d3dce6;
		color: #333;
		text-align: center;
		position: relative;
		height: 100vh;
	}

	.el-main {
		background-color: #e9eef3;
		color: #333;
		text-align: center;
		height: 100vh;
		padding: 0;
	}

	body>.el-container {
		margin-bottom: 40px;
	}

	.el-header {
		text-align: left;
	}

	.flex-max {
		display: flex;
	}

	.flxt {
		width: 25%;
	}

	.el-input__inner {
		width: 200px;
		display: inline-block;
	}

	.storename-max {
		width: 100%;
	}
	.iframe-content{
		height: 500px;
	}
</style>